<template lang="pug">
div
  y-dialog(v-model='showPicker' width='380px' persistent content-class="round-3xl")
    template(v-slot:activator='{ on }')
      v-text-field.text-sm.round-xl(v-model="selectedDateField" :background-color="disabled ? '' : 'neutral100'" placeholder="Select date" outlined dense height="48" :rules="required ? rules.not_empty : []" hide-details="auto" v-on="on" readonly :disabled="disabled")
        template(v-slot:append)
          eva-icon(name="calendar-outline" fill="#848484" style="margin-top: 2px;")
    v-card
      v-card-text.px-2.pt-2.pb-0
        yc-date-picker(:parentDate.sync="selectedDate" :minDate="min" color="info")
      v-card-actions.px-4.pb-4
        v-row(no-gutters)
          v-col.pr-2
            v-btn.button-sm(color="neutral700" block dark outlined depressed @click="closeDate") {{ $t('cancel') }}
          v-col.pl-2
            v-btn.button-sm(color="neutral700" block depressed :dark="Boolean(selectedDate)" :disabled="!selectedDate" @click="selectDate(selectedDate)") {{ $t('select') }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPicker: false,
      selectedDateField: null,
      selectedDate: null,
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.value) this.selectDate(this.value)
    })
  },
  methods: {
    selectDate (date) {
      this.selectedDateField = this.$options.filters.humanizeDate(date)
      this.$emit('input', date)
      this.showPicker = false
    },
    closeDate () {
      this.showPicker = false
      if (!this.selectedDateField) {
        this.$emit('input', null)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.column-width {
  width: 200px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>